import { SelectInput } from "@/lib/Components/Form/Inputs/SelectInput";
import { VehicleCategory } from "@/gql/graphql";

export function VehicleCategoryInput({
  name,
  label,
}: {
  name: string;
  label: string;
}) {
  return (
    <SelectInput<VehicleCategory | "">
      name={name}
      label={label}
      options={[
        {
          label: "Category",
          options: [
            {
              label: "All Vehicles",
              value: "",
            },
            {
              label: "Car",
              value: VehicleCategory.Car,
            },
            {
              label: "Truck",
              value: VehicleCategory.Truck,
            },
            {
              label: "RV",
              value: VehicleCategory.Rv,
            },
          ],
        },
      ]}
    />
  );
}
